import "../../styles/InProgressCoursesSection.scss";
import { useTranslation } from "react-i18next";
import { getPortalURL } from "../../utils/util";

const InProgressCoursesSectionBanner = () => {
	const { t } = useTranslation();

	return (
		<div className="learn-banner-container mb-5">
			<div className="learn-banner-content-container">
				<div className="learn-banner-content">
					<div className="learn-banner-icon">
						<svg
							fill="none"
							height="48"
							viewBox="0 0 48 48"
							width="48"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect fill="#E7EFFF" height="48" rx="10" width="48" />
							<path
								d="M29.9325 20.9171C31.3947 20.9171 32.58 19.7317 32.58 18.2696C32.58 16.8074 31.3947 15.6221 29.9325 15.6221C28.4703 15.6221 27.285 16.8074 27.285 18.2696C27.285 19.7317 28.4703 20.9171 29.9325 20.9171Z"
								stroke="#0B5FFF"
								stroke-linecap="round"
								stroke-miterlimit="10"
								stroke-width="2"
							/>
							<path
								d="M22.3876 30.9895C21.9976 36.682 12.1951 35.962 12.1951 35.962C12.1951 35.962 11.4751 26.1595 17.1676 25.7695"
								fill="#0B5FFF"
							/>
							<path
								d="M20.1375 20.1152L14.22 21.0077C11.37 23.6702 11.25 27.5402 11.25 27.5402C13.6275 25.1627 16.9275 23.9927 17.6475 24.7127"
								stroke="#0B5FFF"
								stroke-miterlimit="10"
								stroke-width="2"
							/>
							<path
								d="M22.68 30.7949C22.68 30.7949 37.845 25.6949 37.0725 11.0774C22.455 10.3049 17.355 25.4699 17.355 25.4699L22.6725 30.7874L22.68 30.7949Z"
								stroke="#0B5FFF"
								stroke-linecap="round"
								stroke-miterlimit="10"
								stroke-width="2"
							/>
							<path
								d="M28.035 28.0127L27.1425 33.9302C24.48 36.7802 20.61 36.9002 20.61 36.9002C22.9875 34.5227 24.1575 31.2227 23.4375 30.5027"
								stroke="#0B5FFF"
								stroke-miterlimit="10"
								stroke-width="2"
							/>
						</svg>
					</div>
					<h2 className="learn-banner-title">
						{t("dashboard-label-inprogress-courses-title")}
					</h2>
				</div>

				<a className="learn-banner-button" href={`${getPortalURL()}/user-dashboard`} id="learn-banner-button">
					<div className="banner-button-text">
						{t("dashboard-label-inprogress-courses-button")}
					</div>
					<svg
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<mask
							height="8"
							id="mask0_2405_9176"
							maskUnits="userSpaceOnUse"
							width="13"
							x="1"
							y="4"
						>
							<path
								d="M11.243 10.9888L13.4805 8.75128C13.818 8.3794 13.8305 7.72315 13.4805 7.32002L11.243 5.08252C10.193 4.15127 8.90234 5.57627 9.81172 6.51377L10.3336 7.03565H2.74609C1.41797 7.03565 1.41797 9.03565 2.74609 9.03565H10.3336L9.81172 9.55752C8.87734 10.5513 10.2773 11.9169 11.243 10.9888Z"
								fill="#6B6C7E"
							/>
						</mask>
						<g mask="url(#mask0_2405_9176)">
							<rect fill="#0B5FFF" height="16" width="16" />
						</g>
					</svg>
				</a>
			</div>
			<div className="learn-banner-background-image">
				<svg
					fill="none"
					preserveAspectRatio="xMidYMid slice"
					viewBox="0 0 497 96"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clip-path="url(#clip0_1588_16796)">
						<path
							d="M553.138 -116.675C216.06 -390.974 -25.2969 494.422 383.877 389.825C762.127 293.177 714.675 14.7608 553.144 -116.678L553.138 -116.675Z"
							fill="url(#paint0_linear_1588_16796)"
						/>
						<path
							d="M202.261 38.7566C-45.2659 228.29 409.167 504.162 571.721 405.116C734.328 306.117 753.239 -43.0397 560.78 -122.751C368.223 -202.453 357.224 -78.335 202.261 38.7566Z"
							fill="url(#paint1_linear_1588_16796)"
						/>
					</g>
					<defs>
						<linearGradient
							id="paint0_linear_1588_16796"
							gradientUnits="userSpaceOnUse"
							x1="490.637"
							x2="357.691"
							y1="-230.687"
							y2="499.274"
						>
							<stop stop-color="white" stop-opacity="0.25" />
							<stop offset="0.64" stop-color="white" stop-opacity="0.08" />
							<stop offset="1" stop-color="white" stop-opacity="0" />
						</linearGradient>
						<linearGradient
							id="paint1_linear_1588_16796"
							gradientUnits="userSpaceOnUse"
							x1="599.595"
							x2="277.979"
							y1="-193.901"
							y2="454.797"
						>
							<stop stop-color="white" />
							<stop offset="0.01" stop-color="white" stop-opacity="0.97" />
							<stop offset="0.13" stop-color="white" stop-opacity="0.75" />
							<stop offset="0.25" stop-color="white" stop-opacity="0.55" />
							<stop offset="0.37" stop-color="white" stop-opacity="0.38" />
							<stop offset="0.49" stop-color="white" stop-opacity="0.24" />
							<stop offset="0.62" stop-color="white" stop-opacity="0.14" />
							<stop offset="0.74" stop-color="white" stop-opacity="0.06" />
							<stop offset="0.87" stop-color="white" stop-opacity="0.01" />
							<stop offset="1" stop-color="white" stop-opacity="0" />
						</linearGradient>
						<clipPath id="clip0_1588_16796">
							<rect
								fill="white"
								height="451.312"
								transform="translate(0 -10.3281) rotate(-25.246)"
								width="451.312"
							/>
						</clipPath>
					</defs>
				</svg>
			</div>
		</div>
	);
};

export default InProgressCoursesSectionBanner;
